export default {
  submit: 'Submit',
  reset: 'Reset',
};
